<div style="width: 700px;" class="p20">
    <div class="pct100 flex-h-c">
        <span class="f16">Date Range</span>
        <i class="fas fa-times poi mla f16" (click)="cancle()"></i>
    </div>
    <ng-container *ngIf="toolbarTemplate">
        <div *ngTemplateOutlet="toolbarTemplate;context:toolbarTplContext"></div>
    </ng-container>
    <div class="mt4em">
        <app-a-date-range-slider [dateScopeStart]="dateScopeStart" [startType]="startType" [endType]="endType" [dateScopeEnd]="dateScopeEnd" [start]="startDate"
            [end]="endDate" (onDateRangeChange)="onDateRangeChange($event)" [format]="format">
        </app-a-date-range-slider>
    </div>
    <div class="flex-h-c mt2em">
        <ad-button (onClick)="resetDefaultValue()" [styleClass]="{ 'btn-link': true }" iconClass="fas fa-sync">
            Reset to Default
        </ad-button>
        <ad-button (onClick)="cancle()" class="mla mr2em" [styleClass]="{ 'btn-link': true }">
            Cancel
        </ad-button>
        <ad-button (onClick)="apply()" width="150px">
            Apply
        </ad-button>
    </div>
</div>